<template>
    <div class="field">
        <!-- <MultiSelectDropdown label="Code" v-model="ObjServiceType.pocode" :items="options.pocodearray"
            @update:modelValue="" /> -->
        <!-- <TextInput v-model="ObjServiceType.code" placeholder=" " :requiredIcon="false" clearable name="Code" id="Code"
            label="Code" :rules="{ required: false }" /> -->
        <label>Code</label>
        <CustomAutoComplete name="Code" id="Code" v-model="ObjServiceType.code" :items="options.fromsCodearray"
            @item-select="passdata" :required-icon="true" :rules="{ required: true, alphanumeric: true }" />
    </div>
    <div class="field" v-if="storedd">
        <MultiSelectDropdown label="From Store" v-model="ObjServiceType.fromstore" :items="options.fromstorearray"
            @update:modelValue="updatedSupplier" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue'
import MultiSelectDropdown from "../../../../components/FormComponents/MultiSelectDropdown.vue";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import StoreService from "../../../../modules/Inventory/Service/StoreService";
import { useRoute, useRouter } from "vue-router";
import CustomAutoComplete from "../../../../components/FormComponents/AutoComplete.vue";


export default defineComponent({
    components: {
        CustomAutoComplete,
        MultiSelectDropdown,
        TextInput,
    },

    props: {
        removechiptype: {
            type: Number,
            default: 0
        },
        storedd: {
            type: Boolean,
            default: false
        },
        itemsList: {
            type: Array,
            default: []
        },
    },

    setup(props, { emit }) {
        const router = useRouter();
        const route = useRoute();
        let StoreID = route.query.Id
        const ObjServiceType = ref({
            code: ref(),
            fromstore: ref(),
            returncode:ref()
        });
        let options: any = ref({
            fromstorearray: []
        })
        let FromStoreNames = ref('');
        let FromStoreIds = ref('');

        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }
        onMounted(() => {
            Loadstores()
            let SessionUserData = localStorage.getItem("UsersData");
            if (SessionUserData !== null) {
                usersData = JSON.parse(SessionUserData);
            }
        })
        const Loadstores = async () => {
            const response = await StoreService.getStoreByStoreId(StoreID, usersData.OrganizationId,
                usersData.BranchId);
            console.log(response);
            options.value.fromstorearray = response["result"].map((item) => {
                item.name = item.Name;
                item.value = item.StoreId;
                return item;
            });
        }
        function passdata(data) {
            // alert(JSON.stringify(data.value))
            ObjServiceType.value.code = data.value.DocNo


        }
        watch(
            () => ObjServiceType.value.code,
            (newVal) => {
                debugger;
                //    alert('s')
                options.value.fromsCodearray = props.itemsList.map((item:any) => {
                    item['label'] = item['DocNo'];
                    item['value'] = item['DocNo'];
                    return item;
                });
            }
        );
        watch(
            () => ObjServiceType.value.fromstore,
            (newVal) => {
                emit("suppliersename", FromStoreNames.value);
                emit("supplierseid", FromStoreIds.value);
            }
        );

        watch(
            () => ObjServiceType.value.code,
            (newVal) => {
                emit("updatedcode", ObjServiceType.value.code);
            }
        );

        function updatedSupplier() {
            debugger;
            FromStoreIds.value = '';
            const selectedValues = ObjServiceType.value.fromstore;

            if (selectedValues && Array.isArray(selectedValues)) {
                const selectedNames: any = [];
                const selectedIds: any = []
                selectedValues.forEach((selectedValue) => {
                    const selectedOption = options.value.fromstorearray.find(
                        (option) => option.value === selectedValue
                    );
                    const selectedIdOption = options.value.fromstorearray.find(
                        (option) => option.value === selectedValue
                    );
                    if (selectedOption) {
                        const selectedName = selectedOption.Name;
                        selectedNames.push(selectedName);
                    }
                    if (selectedIdOption) {
                        const selectedName = selectedOption.StoreId;
                        selectedIds.push(selectedName);
                    }
                });
                console.log("Selected Names:", selectedNames.join(", "));
                if (selectedNames.length > 2) {
                    FromStoreNames.value = selectedNames.slice(0, 2).join(", ") + ", ...";
                } else {
                    FromStoreNames.value = selectedNames.join(", ");
                }
                if (selectedIds.length > 0) {
                    FromStoreIds.value = selectedIds.join(", ");
                }
                console.log(FromStoreIds.value);

            }
        }


        watch(
            () => props.removechiptype,
            (newVal) => {
                if (newVal == 1) {
                    debugger;
                    ObjServiceType.value.code = ''
                } else if (newVal == 2) {
                    ObjServiceType.value.fromstore = ''
                    FromStoreNames.value = ''
                    FromStoreIds.value = ''
                } else if (newVal == 3) {
                    ObjServiceType.value.code = ''
                    ObjServiceType.value.fromstore = ''
                    FromStoreNames.value = ''
                    FromStoreIds.value = ''
                }

            }
        );
        return {
            passdata,
            ObjServiceType,
            options,
            updatedSupplier,
            FromStoreIds,
        }
    }
})
</script>

<style lang="scss" scoped></style>